const scrollToContinue = {
  methods: {
    $_scroll_toElement (element, duration) {
      let startingY = window.pageYOffset
      let elementY = this.$_scroll_getElementY(element)
      // If element is close to page's bottom then window will
      // scroll only to some position above the element.
      let targetY = document.body.scrollHeight - elementY < window.innerHeight
        ? document.body.scrollHeight - window.innerHeight
        : elementY
      let diff = targetY - startingY

      const easing = (t) => {
        // cubic bezier function copied from https://gist.github.com/gre/1650294
        return t < 0.5 ? 4 * t * t * t
          : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
      }

      let start
      if (!diff) return

      const step = timestamp => {
        if (!start) start = timestamp
        // Elapsed miliseconds since start of scrolling.
        let time = timestamp - start
        // Get percent of completion in range [0, 1].
        let percent = Math.min(time / duration, 1)
        percent = easing(percent)
        window.scrollTo(0, startingY + diff * percent)

        if (time < duration) {
          window.requestAnimationFrame(step)
        }
      }

      // Bootstrap our animation - it will get called right
      // before next frame shall be rendered.
      window.requestAnimationFrame(step)
    },

    $_scroll_getElementY (query) {
      if (!document.querySelector(query)) return
      return window.pageYOffset +
        document.querySelector(query).getBoundingClientRect().top - 200
    }
  }
}

export default scrollToContinue
